import React from 'react';
import { useDispatch } from 'react-redux';
import { removeAccents } from '../../../utils';
import swal from 'sweetalert';

import { 
    Paper,
    Stack,
    Typography,
    Divider,
    Card,
    CardContent,
    Grid,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Table
} from '@mui/material';

import { FaArrowCircleLeft, FaArrowCircleRight } from "react-icons/fa";
import { BiSave } from "react-icons/bi";
import { fetchInsertOrUpdatSeleccionCombosSemanal } from '../../../redux/Cafeteria/CafeteriaSlice';

export const RegistroSeleccionMenuCombosEmpleado = (
    {
        stepPosition, 
        setStepPosition,
        diasSemanas, 
        usuarioAplicaSubsidio = false,
        comboFilterDay = [],
        combosWatch = {},
        semana = {},
        usuarioId = 0,
        semanaId = 0,
        form : { setValue, watch}
    }
) => {

    // ? HOOK-DISPATCH
    const dispatch = useDispatch();

    // * DESESTRUCTURACION DE DATOS
    const { diaId, position } = stepPosition;

    // * DIA SELECCIONADO.
    const dia = diasSemanas.find(x => x.id === diaId)?.descripcion ?? '';

    // * DIA NORMALIZADO
    const diaNormalized = removeAccents(dia).toLocaleLowerCase();

    // * ORDENAR EL ARRAY DE OBJETOS DE LA SELECCION DE MENU SEMANAL RRHH.
    const ordenDias = ["lunes", "martes", "miercoles", "jueves", "viernes"];
  
    // * ORDENANDO LISTA
    const diasOrdenados = Object.fromEntries(
      Object.entries(combosWatch)
          .sort((a, b) => ordenDias.indexOf(a[0]) - ordenDias.indexOf(b[0]))
    );

    // * FUNCION PARA GUARDAR DATOS DE LA API
    const saveSeleccionCombo = () => {

        // * VALIDACION DONDE SE VERIFICA QUE EL OBJETO TENGA ALGUN VALOR PARA EVITAR
        // * MANDAR UN ARRAY VACIO.
        if(Object.values(combosWatch).every(day => Object.keys(day).length === 0) )
        {
            swal("Error", "Debe seleccionar una opción por lo menos.", "error");
            return;
        }

        // * ARRAY CON LA DATA A ENVIAR A BACK-END
        let arrData = [];

        for (let i = 0; i < diasSemanas.length; i++) {

            const { descripcion : dia} = diasSemanas[i];

            let combo = combosWatch[removeAccents(dia).toLocaleLowerCase()] ?? {};

            if(Object.keys(combo).length > 0){

                arrData.push({
                    id: 0,
                    empleadoId: usuarioId,
                    comboId: combo.id,
                    fechaCreacion: new Date()
                })

            }
            
        }

        // * GUARDANDO DATA.
        dispatch(fetchInsertOrUpdatSeleccionCombosSemanal({data: arrData, semanaId}))
    }

  return (
    <Paper>
        <Stack p={3} sx={{ minWidth: 100 }} >
            <Typography variant='h6'>{ position < 5 ? dia : "Resumen del Menú de la semana"}</Typography>
            <Divider />

            {
                position < 5 ?
                
                    <Stack m={2} pb={3} mt={5}>
                        <Grid container spacing={3}>

                        {
                            comboFilterDay?.combos?.map((item) => (
                                <Grid item xs={4} key={item.numeracion}>
                                   {
                                        (semana?.estatus && usuarioAplicaSubsidio)? 
                                            <Card 
                                            onClick={() => (watch(`combosEmpleado.${diaNormalized}`)?.id === item.id && watch(`combosEmpleado.${diaNormalized}`)?.seleccionado) 
                                                            ? setValue(`combosEmpleado.${diaNormalized}`, {})
                                                            : setValue(`combosEmpleado.${diaNormalized}`, {...item, seleccionado: true})
                                                        }
                                            sx={{
                                                cursor: "pointer",
                                                transition: "0.3s",
                                                boxShadow: watch(`combosEmpleado.${diaNormalized}`)?.id === item.id && "0px 0px 20px 3px #003876",
                                                border: watch(`combosEmpleado.${diaNormalized}`)?.id === item.id && "2px solid blue",
                                                height: 200
                                            }}
                                            >
                                            <CardContent>
                                                <Typography fontWeight="bold" fontSize={18}>
                                                    Combo #{item.numeracion}
                                                </Typography>
                                                <Divider />
                                                <Stack mt={2}>
                                                    <ul>
                                                        {item.comidas.map((comida, index) => (
                                                            <li key={index}>{comida.descripcion}</li>
                                                        ))}
                                                    </ul>
                                                </Stack>
                                            </CardContent>
                                        </Card>

                                        :

                                            <Card 
                                            sx={{
                                                opacity: !semana?.estatus || !usuarioAplicaSubsidio ? 0.5 : 1,
                                                pointerEvents: !semana?.estatus || !usuarioAplicaSubsidio ? 'none' : 'auto',
                                                cursor: "pointer",
                                                transition: "0.3s",
                                                boxShadow: watch(`combosEmpleado.${diaNormalized}`)?.id === item.id && "0px 0px 20px 10px #003876",
                                                border: watch(`combosEmpleado.${diaNormalized}`)?.id === item.id && "2px solid blue",
                                                height: 200
                                            }}
                                            >
                                            <CardContent>
                                                <Typography fontWeight="bold" fontSize={18}>
                                                    Combo #{item.numeracion}
                                                </Typography>
                                                <Divider />
                                                <Stack mt={2}>
                                                    <ul>
                                                        {item.comidas.map((comida, index) => (
                                                            <li key={index}>{comida.descripcion}</li>
                                                        ))}
                                                    </ul>
                                                </Stack>
                                            </CardContent>
                                        </Card>
                                   }
                                </Grid>
                            ))
                        }

                        
                    </Grid>
                </Stack>

                : 
                
                <>
                
                    <Table component={Paper} sx={{ mt: 2 }}>
                        {
                            Object.keys(diasOrdenados).map((dia, index) => (
                                <React.Fragment key={index}>
                                    {/* Encabezado del día */}
                                    <TableRow>
                                    <TableCell sx={{ backgroundColor: '#003876', p: 1}}>
                                        <Typography fontSize={16} fontWeight="bold" color="white">
                                        {diasSemanas.find(x => removeAccents(x.descripcion).toLowerCase() === dia)?.descripcion}
                                        </Typography>
                                    </TableCell>
                                    </TableRow>
        
                                    {/* Tabla de combos para el día */}
                                    <TableRow>
                                        <TableCell>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ fontWeight: 'bold' }} width='15%'>Combo</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold' }}>Comida</TableCell>
                                                    </TableRow>
                                                </TableHead>
                
                                                <TableBody>
                                                    {Object.keys(combosWatch[dia])?.length > 0 ? (
                                                        <TableRow>
                                                            <TableCell>{combosWatch[dia]?.numeracion}</TableCell>
                                                            <TableCell>
                                                                <Typography>
                                                                {combosWatch[dia]?.comidas?.length
                                                                    ? combosWatch[dia]?.comidas
                                                                        .filter(comida => comida.descripcion?.trim()) // Filtra descripciones vacías
                                                                        .map(comida => comida.descripcion)
                                                                        .join(", ")
                                                                    : "Sin comidas"}
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : 
                                                    (
                                                        <TableRow>
                                                            <TableCell colSpan={3} align="center">
                                                            No hay registros
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            ))
                        }
                    </Table>
                
                
                </>
            }

            <div className='mt-2 d-flex justify-content-end'>
                <button style={{marginRight: 4}} hidden={position === 0} onClick={() => setStepPosition({diaId: diaId - 1, position: position - 1 })} className='btn btn-primary-mem'><FaArrowCircleLeft style={{marginBottom: 4}} /> Anterior</button>
                <button hidden={position === 5} onClick={() =>  setStepPosition({diaId: diaId + 1, position: position + 1 })} className='btn btn-primary-mem'>Siguiente <FaArrowCircleRight style={{marginBottom: 4}} /> </button>
                <button hidden={position < 5 | !semana?.estatus | !usuarioAplicaSubsidio} onClick={() => saveSeleccionCombo()} className='btn btn-primary-mem'>Guardar <BiSave style={{marginBottom: 3}} fontSize={22} /></button>
            </div>
        </Stack>
    </Paper>
  )
}
